defineDs('DanskeSpil/Domain/PlayTogether/Scripts/Templates/PurchaseFlow/ChooseGame',
  [
    'Shared/Framework/Mithril/Scripts/Core/Mithril',
    'DanskeSpil/Domain/PlayTogether/Scripts/Helpers/Utils',
    'DanskeSpil/Framework/NumberGames/Scripts/Helpers/AccountIntegration',
    'DanskeSpil/Domain/Lotto/Scripts/Helpers/LottoInfo',
    'DanskeSpil/Domain/VikingLotto/Scripts/Helpers/VikingLottoInfo',
    'DanskeSpil/Domain/Eurojackpot/Scripts/Helpers/EurojackpotInfo',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Loader',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/PurchaseFlow/GameOptionCard'
  ],
  function (m, Utils, AccountIntegration, LottoInfo, VikingLottoInfo, EurojackpotInfo, Loader, GameOptionCard) {

    var ChooseGame = {
      controller: function ({ controller }) {
        Object.assign(this, controller);

        this.loading = m.prop(true);
        this.availableGames = this.settings.playTypes || [];

        m.sync([LottoInfo.ready, VikingLottoInfo.ready, EurojackpotInfo.ready, AccountIntegration.ready]).then(() => {
          this.availableGames.forEach((playType) => {
            let date = null;
            let isOpen = false;
            let fundingEndTime = null;

            if (playType.gameType === 'lotto' &&
              !LottoInfo.saturday().noOpenDraw() &&
              LottoInfo.saturday().getOpenDraw()) {
              date = LottoInfo.saturday().getOpenDraw().closingTime;
              isOpen = true;
            } else if (playType.gameType === 'vikinglotto' &&
              !VikingLottoInfo.noOpenDraw()) {
              date = VikingLottoInfo.getOpenDraw().closingTime;
              isOpen = true;
            } else if (playType.gameType === 'eurojackpot' &&
              !EurojackpotInfo.noOpenDraw()) {
              date = EurojackpotInfo.getOpenDraw().closingTime;
              isOpen = true;
            }

            if (date) {
              // We subtract 3 hours from closingTime, because this is the fundingEndTime for PlayTogether fundings
              fundingEndTime = Utils.parseISO8601(date).dateObject;
              fundingEndTime.setHours(fundingEndTime.getHours() - 2);
              playType.fundingDayName = Utils.parseISO8601(fundingEndTime.toISOString()).dayName;
            }

            playType.fundingEndTime = fundingEndTime;
            playType.isOpen = isOpen;
          });

          this.loading(false);
        });
      },
      view: function (controller) {
        if (controller.loading()) {
          return Loader(controller);
        }
        return m('.play-together__purchase-flow.play-together__choose-game', [
          m('.choose-game__options', controller.availableGames.map(function (game) {
            return m(GameOptionCard, { controller, game });
          }))
        ]);
      }
    };

    // Public functions:
    return ChooseGame;
  });
